// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"418":"e7ab9143","480":"20fc5143"}[chunkId] + ".js";
};